import initApp from '@springboardjs/platforms-browser/entrypoints/offline_entrypoint.ts';
import '../../../../src/index.tsx';
export default initApp;
